import apiFetch from '../apiFetch'

export default function (token, dossierSubTypeId) {
  return apiFetch({ endPoint: `paperworkType/subtypes?dossierSubTypeId=${dossierSubTypeId}`, method: 'GET', token: token })
}
